import * as React from 'react';

import {
  Paper,
  Rows,
  BaseComponentProps,
  useIsSmallScreen,
} from '@numbox/components';

export interface PromptProps extends BaseComponentProps {
  variant?: 'standard' | 'auth';
  width?: number;
  children: React.ReactNode;
  onKeyDown?: React.KeyboardEventHandler<HTMLDivElement>;
}

export const Prompt = ({
  variant = 'standard',
  children,
  onKeyDown,
  width = 600,
  ...rest
}: PromptProps) => {
  const isSmallScreen = useIsSmallScreen();
  let maxWidth: React.CSSProperties['maxWidth'] = '100%';
  if (!isSmallScreen) {
    maxWidth = variant === 'auth' ? 400 : 850;
  }
  return (
    <Rows
      sx={{
        maxWidth,
        minWidth: variant === 'auth' ? maxWidth : undefined,
        width: variant === 'auth' ? undefined : width,
        marginX: 'auto',
      }}
    >
      <Paper
        onKeyDown={onKeyDown}
        saveHorizontalSpace
        saveVerticalSpace={variant !== 'auth'}
        {...rest}
      >
        <Rows paddingY={2} spacing={2}>
          {children}
        </Rows>
      </Paper>
    </Rows>
  );
};
